const items = [
  "Amazon",
  "Shopify",
  "Blinkit",
  "Zepto",
  "Instamart",
  "Flipkart",
  "D2C",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-coal/10 py-8 overflow-hidden bg-midnight"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display font-900 text-6xl sm:text-8xl tracking-tighter text-outline px-8 select-none">
                  {item}
                </span>
                <span className="w-2.5 h-2.5 rotate-45 bg-terracotta/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
